<div class="title-row flex">
  <div
    class="title"
    data-testid="title"
  >
    {{ data.transition.label }}
  </div>
  @if (data.transition.hide_from_events) {
    <mat-icon
      class="hide-from-events-icon"
      title="Nem jelenik meg az eseményekben"
    >
      visibility_off
    </mat-icon>
  }
  @if (data.transition.hide_from_actions) {
    <span
      class="hide-from-actions-icon"
      title="Rejtve a műveletek menüben"
    >
      <mat-icon inline>menu</mat-icon>
    </span>
  }
  <button
    class="copy-node-text"
    payee-mini-icon-button
    color="white"
    title="Címke másolása"
    data-testid="copy-node-text"
    (click)="copyNodeText($event)"
    (mousedown)="$event.stopPropagation()"
  >
    <mat-icon>content_copy</mat-icon>
  </button>
</div>
<div class="meta-info">
  <span>{{ data.transition.class_name }}</span>
</div>
<div class="meta-info">
  <span>{{ data.transition.log_label }}</span>
</div>
<div class="meta-info">
  <span>
    {{ data.transition.roles === null ? "anyone" : data.transition.roles.join(", ") }}
  </span>
</div>
<div class="flex connections">
  <div class="flex column inputs">
    @for (input of data.inputs | keyvalue; track input.key) {
      <div
        class="input"
        [attr.data-testid]="'input-' + input.key"
      >
        <div
          class="input-socket"
          refComponent
          data-testid="input-socket"
          [data]="{
            type: 'socket',
            side: 'input',
            key: input.key,
            nodeId: data.id,
            payload: input.value?.socket,
            seed: seed,
          }"
          [emit]="emit"
        ></div>
      </div>
    }
  </div>
  <button
    class="details-toggle"
    payee-mini-icon-button
    color="white"
    (click)="toggleTransitionDetails($event)"
  >
    @if (!showDetails) {
      <mat-icon>expand_more</mat-icon>
    }
    @if (showDetails) {
      <mat-icon>expand_less</mat-icon>
    }
  </button>
  <div class="flex column outputs">
    @for (output of data.outputs | keyvalue; track output.key) {
      <div
        class="output"
        [attr.data-testid]="'output-' + output.key"
      >
        <div
          class="output-socket"
          refComponent
          data-testid="output-socket"
          [data]="{
            type: 'socket',
            side: 'output',
            key: output.key,
            nodeId: data.id,
            payload: output.value?.socket,
            seed: seed,
          }"
          [emit]="emit"
        ></div>
      </div>
    }
  </div>
</div>
@if (showDetails) {
  <div class="details">
    @if (data.transition.dialog) {
      <div class="detail-title">Dialog</div>
      <li class="detail-value">
        {{ data.transition.dialog }}
      </li>
    }
    <div class="detail-title">
      Határidők teljesítve:
      {{ data.transition.mark_deadlines_complete ? "Igen" : "Nem" }}
    </div>
    <div class="detail-title">
      Időzített értesítések törlése:
      {{ data.transition.delete_pending_notifications ? "Igen" : "Nem" }}
    </div>
    @if (data.transition.notifications.length > 0) {
      <div class="detail-title">Értesítések</div>
      <ul>
        @for (notification of data.transition.notifications; track notification.id) {
          <li class="detail-value">
            <span>{{ notification.label }}</span>
            <mat-icon
              class="preview-notification"
              (click)="previewNotification($event, notification)"
            >
              outbound
            </mat-icon>
          </li>
        }
      </ul>
    }
  </div>
}
